import { isWMSLayer, useSelectedBackgroundLayer } from "hooks/mapHooks";
import { TileLayer, WMSTileLayer } from "react-leaflet";

export function RenderBackgroundLayer() {
  const backgroundLayer = useSelectedBackgroundLayer();
  return (
    <>
      {isWMSLayer(backgroundLayer) && (
        <WMSTileLayer
          {...backgroundLayer.wms}
          zIndex={0}
          maxZoom={24}
          key={backgroundLayer.id}
        />
      )}
      {!isWMSLayer(backgroundLayer) && (
        <TileLayer
          url={backgroundLayer.url}
          zIndex={0}
          maxZoom={24}
          key={backgroundLayer.id}
          maxNativeZoom={backgroundLayer.nativeZoom}
        />
      )}
    </>
  );
}
